import { IAction } from '../@types/contextReducers';

export const createAction =
  <T, P = undefined>(type: T): ((pay: P) => IAction<T, P>) =>
  (payload) => ({
    type,
    payload
  });
